<ndt-add-device-view
   [callState]="callState | async"
   [form]="form"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
   (saveAndAddAnother)="onCreateAndAddAnother()"
>
</ndt-add-device-view>
